var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TablePaginated',{attrs:{"label":_vm.activeRouteName,"main-list":_vm.itemData,"is-global-percent":_vm.isGlobalPercent,"is-mark-active-item":"","is-active":""},on:{"setActiveItem":_vm.setActiveFilterItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }